export default {
  data () {
    return {
      booking: {
        min10km: 9,
        plus10km: 0.9,
        mutualPatientAmount: 0,
        mutualDistance: 0,
        total: 0
      }
    }
  },
  methods: {
    calcMutas (mutualDistance, mutualPatientAmount) {
      var booking = this.booking;
      booking.mutualDistance = Number(mutualDistance);
      booking.mutualPatientAmount = Number(mutualPatientAmount) || 0;
      booking.total = (Number(booking.mutualDistance) < 11 ? booking.min10km : booking.min10km + (Number(booking.mutualDistance - 10) * booking.plus10km));
      if (booking.mutualPatientAmount > 0) {
        booking.total -= booking.mutualPatientAmount;
      }
      this.showMutas(booking);
      return booking;
    },
    calcTarif (distance) {
      var d = Math.ceil(distance / 1000);
      var forfait10km = 16;
      var from11to30 = 0;
      var above30 = 0;
      d -= 10;
      if (d > 0) {
        if (d > 20) {
          from11to30 = 20 * 1.78;
          above30 = (d - 20) * 1.2;
        } else {
          from11to30 = (d * 1.78);
        }
      }
      /*
      {label: "forfait10km", km: 10, costTotal: 16}
      {label: "from11to30", km: 20, costUnit: 1.78, costTotal: 35.6}
      {label: "above30", km: 64, costUnit: 1.2, costTotal: 76.8}
      */
      return (Math.round((forfait10km + from11to30 + above30) * 100) / 100).toFixed(2);
    },
    showMutas (booking) {
      var html, newdiv;

      newdiv = document.createElement('div');
      html = '<div >MUTAS ' + '<div class="totals">';
      html += '<div>' + '<span>Aller  : </span>' + booking.mutualDistance.round(1) + ' km - ' + booking.total + ' eur</div>';
      html += '<div>' + '<span>Total (Aller + retour) : </span>' + (booking.total * 2) + ' eur</div>';
      html += '</div></div>';

      newdiv.innerHTML = html;

      this.outputDiv = this.$refs.mutas.$el;

      if (this.outputDiv.firstChild) {
        this.outputDiv.removeChild(this.outputDiv.firstChild);
      }
      this.outputDiv.appendChild(newdiv);
    }
  }
}
